export const selectAuthMask = state => state.auth.authMask
export const selectIsUserAuthorized = state => state.auth.isAuth || state.auth.isImpersonationAuth
export const selectIsImpersonationAuthorized = state => state.auth.isImpersonationAuth
